<script setup>
import { computed } from "vue";
import {
  getStatusColor,
  getStatusLabel,
} from "@/shared/config/statusDictionary";

const props = defineProps({
  code: {
    type: String,
    default: "",
  },
  size: {
    type: Number,
    default: 8,
  },
});

const visible = computed(() => Boolean(props.code));
const color = computed(() => getStatusColor(props.code));
const ariaLabel = computed(() => getStatusLabel(props.code));
const dotStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
  backgroundColor: color.value,
  borderRadius: "9999px",
  display: "inline-block",
  flexShrink: 0,
}));
</script>

<template>
  <span
    v-if="visible"
    :style="dotStyle"
    role="status"
    :aria-label="ariaLabel"
  />
</template>
